
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'jmkw-radio',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioComponent {
  @Input() id?: string;
  @Input() name = 'default';
  @Input() selectedId?: string;
  @Input() label?: string;

  @Output() selectChanged = new EventEmitter<string>();

  @ViewChild('radio', { static: true })
  radioRef!: ElementRef<HTMLInputElement>;

  radioChangeHandler(id: string): void {
    this.selectChanged.emit(id);
  }
}
